module.exports = {"140881001":"城西街道","140881002":"城北街道","140881003":"城东街道","140881100":"虞乡镇","140881101":"卿头镇","140881102":"开张镇","140881103":"栲栳镇","140881104":"蒲州镇","140881105":"韩阳镇","140881106":"张营镇","140881400":"伍姓湖农场","140881401":"虞乡农场","140881402":"董村农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140881.json
// module id = 303
// module chunks = 0